import React from 'react';
import PhoenixDocCard from 'components/base/PhoenixDocCard';
import ConnectionMcpServer from './ConnectionMcpServer';

const DataAccessMcpServerPage: React.FC = () => (
  <PhoenixDocCard className="mb-4">
    <PhoenixDocCard.Body>
      <ConnectionMcpServer />
    </PhoenixDocCard.Body>
  </PhoenixDocCard>
);

export default DataAccessMcpServerPage;
